import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Areas from "@/pages/Areas";
import Households from "@/pages/Households";
import HouseholdView from "@/pages/HouseholdView";
import Meters from "@/pages/Meters";
import MeterDetail from "@/pages/MeterDetail";
import Simulator from "@/pages/Simulator";
import Alarms from "@/pages/Alarms";
import Payments from "@/pages/Payments";
import Analytics from "@/pages/Analytics";
import UsersPage from "@/pages/Users";
import Configurations from "@/pages/Configurations";
import AtCommands from "@/pages/AtCommands";
import HouseholdPublicCard from "@/pages/HouseholdPublicCard";
import FieldLayout from "@/pages/field/FieldLayout";
import FieldHome from "@/pages/field/FieldHome";
import FieldScanner from "@/pages/field/FieldScanner";
import FieldHouseholdView from "@/pages/field/FieldHouseholdView";
import FieldDeliveries from "@/pages/field/FieldDeliveries";
import StationApp from "@/pages/station/StationApp";
import Supply from "@/pages/Supply";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/h/:id" element={<HouseholdPublicCard />} />
          <Route
            path="/field"
            element={
              <ProtectedRoute>
                <FieldLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<FieldHome />} />
            <Route path="scan" element={<FieldScanner />} />
            <Route path="h/:id" element={<FieldHouseholdView />} />
            <Route path="deliveries" element={<FieldDeliveries />} />
          </Route>
          <Route path="/station" element={<ProtectedRoute><StationApp /></ProtectedRoute>} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="households" element={<Households />} />
            <Route path="households/:id" element={<HouseholdView />} />
            <Route path="payments" element={<Payments />} />
            <Route path="supply" element={<Supply />} />
            <Route path="meters" element={<Meters />} />
            <Route path="meters/:id" element={<MeterDetail />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="configurations" element={<Configurations />} />
            <Route path="at-commands" element={<AtCommands />} />
            {/* Legacy routes — still reachable, now surfaced from Configurations */}
            <Route path="areas" element={<Areas />} />
            <Route path="simulator" element={<Simulator />} />
            <Route path="alarms" element={<Alarms />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
